<template>
  <div class="form-group" v-bind:class="{ 'has-error': error }">
    <label v-if="label" :for="name">{{ label }}</label>
    <input type="number"
           @input="updateValue($event.target.value)"
           @keyup="checkMax()"
           :value="value"
           :name="name"
           :step="step"
           :min="min"
           :max="max"
           :required="required"
           :placeholder="placeholder"
           class="form-control"
    >
    <span v-if="error"
          class="help-block"
          v-html="error"
    ></span>
  </div>
</template>

<script>
  export default{
    name: 'InputNumber',
    props: ['name', 'value', 'step', 'min', 'max', 'required', 'label', 'placeholder', 'error'],
    methods: {
      updateValue (value) {
        this.$emit('input', value)
      },
      checkMax () {
        if (this.value > this.max) {
          this.$emit('input', this.max)
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// InputNumber.vue?ae03747a